import React from 'react';
import PropTypes from 'prop-types';

export default class PickClass extends React.Component {
	static propTypes = {
		classList: PropTypes.object,
		onChange: PropTypes.func,
		onNextPage: PropTypes.func,
	};

	constructor( props ) { 
		super( props );

		this.state = { 
		};
	}

	pickClass( val ) { 
		this.props.onChange( 'classnum', val );
		this.props.onNextPage();
	}

	showClasses() { 


		const months = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ];
		return this.props.classList.map( item => { 
			let d = new Date( item.enddate * 1000 );
			return <div className="class_item" key={ item.classnum }>
				<h2>{ item.classname }</h2>
				<div className="enddate">Ends: { months[ d.getMonth() ] + ' ' + d.getDate() + ', ' + d.getFullYear() }</div>
				<ul>
					{ !item.no_email_limit ? <li>A school email is required for this class</li> : [] }
					{ item.require_password ? <li>A password is required for this class</li> : [] }
					{ item.student_pay ? <li>You will pay for this account</li> : [] }
					{ item.select_domain_dragonteach ? <li>You will be able to choose a subdomain on dragonteach.com</li> : [] }
					{ item.select_domain_other ? <li>You will be able to choose a subdomain on { item.select_domain_other }</li> : [] }
				</ul>					
				<div className="button_container">
					<input type="button" value="Use This Class" onClick={ () => { this.pickClass( item.classnum ); } } />
				</div>

			</div>;
		} );
		
	}

	render() {
		if( ! this.props.classList ) { return <div></div>; }
		return ( <div className="signupprocess_container">
			<h2>Pick your class:</h2>
			{ ! this.props.classList || this.props.classList.length === 0 ? 
				<div style={ { textAlign: 'center', fontSize: '20px' } } >Your instructor has not created any classes yet</div>  :

				<div className="class_list">
					{ this.showClasses() }
				</div>
			}
		</div>
		);
	}
}